import { gql } from '@apollo/client'

export const CUSTOMER_REQUEST_TEST_SESSION = gql`
  mutation CustomerRequestTestSession($inputData: CustomerRequestTestSessionInput!) {
    customerRequestTestSession(inputData: $inputData)
  }
`
